<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Resultado do cadastro na APS
      </h4>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>Total</th>
            <th>
              {{ labelColunaAtualizados }}
              <span
                v-b-tooltip.hover
                :title="textTooltipAtualizados"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              {{ labelColunaDesatualizados }}
              <span
                v-b-tooltip.hover
                :title="textTooltipDesatualizados"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ this.$store.state.cidade }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosResultadoMunicipio.total"
                :loading="loading"
              ></loader>
            </td>

            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoMunicipio.total / 100) *
                  dadosResultadoMunicipio.atualizados
                ).toFixed(0)} (${dadosResultadoMunicipio.atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoMunicipio.total / 100) *
                  dadosResultadoMunicipio.desatualizados
                ).toFixed(0)} (${dadosResultadoMunicipio.desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>{{ equipe != '' ? equipe.no_equipe : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosResultadoEquipe.total"
                :loading="loading"
              ></loader>
            </td>

            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoEquipe.total / 100) *
                  dadosResultadoEquipe.atualizados
                ).toFixed(0)} (${dadosResultadoEquipe.atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoEquipe.total / 100) *
                  dadosResultadoEquipe.desatualizados
                ).toFixed(0)} (${dadosResultadoEquipe.desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>{{ micro_area != '' ? 'MICROÁREA ' + micro_area : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosResultadoMicroArea.total"
                :loading="loading"
              ></loader>
            </td>

            <td class="text-center green font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoMicroArea.total / 100) *
                  dadosResultadoMicroArea.atualizados
                ).toFixed(0)} (${dadosResultadoMicroArea.atualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center red font-weight-bold">
              <loader
                :value="`${(
                  (dadosResultadoMicroArea.total / 100) *
                  dadosResultadoMicroArea.desatualizados
                ).toFixed(0)} (${dadosResultadoMicroArea.desatualizados}%)`"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal
        texto="Cadastros registrados até"
        :data="data_secretaria_de_saude"
      />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  components: {
    Loader,
  },
  props: {
    labelColunaAtualizados: {
      type: String,
      default: '',
    },
    labelColunaDesatualizados: {
      type: String,
      default: '',
    },
    disabledSelectResultado: {
      type: Boolean,
      default: false,
    },
    resetarSelectTabelaResultado: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dadosResultadoMunicipio: {
      type: Object,
      default: () => {},
    },
    dadosResultadoEquipe: {
      type: Object,
      default: () => {},
    },
    dadosResultadoMicroArea: {
      type: Object,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    equipe: {
      type: [String, Object],
      default: () => {},
    },
    micro_area: {
      type: [String],
      default: '',
    },
  },
  data() {
    return {
      indicador: null,
      textTooltipAtualizados:
        'Cidadãos com cadastro atualizado há menos de 2 anos e completos',
      textTooltipDesatualizados:
        'Cidadão com cadastro desatualizados há mais de 2 anos ou incomplentos',
    }
  },
  mounted() {},
  watch: {
    labelColunaAtualizados: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case 'Atualizados e completos':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro atualizado há menos de 2 anos e completos'
            break
          case 'Atualizados':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro atualizado há menos de 2 anos'
            break
          case 'Completos':
            this.textTooltipAtualizados =
              'Cidadãos com cadastro FCI completo (menos de 2 anos)'
            break
          default:
            break
        }
      },
    },
    labelColunaDesatualizados: {
      handler(newValue, oldValue) {
        switch (newValue) {
          case 'Desatualizados ou incompletos':
            this.textTooltipDesatualizados =
              'Cidadão com cadastro desatualizados há mais de 2 anos ou incomplentos'
            break
          case 'Desatualizados':
            this.textTooltipDesatualizados =
              'Cidadãos com cadastro atualizado há mais de 2 anos'
            break
          case 'Incompletos':
            this.textTooltipDesatualizados =
              'Cidadãos com cadastro FCI incompleto (mais de 2 anos)'
            break
          default:
            break
        }
      },
    },
  },
  methods: {
    onChangeIndicador(indicador) {
      this.$emit('onChangeIndicador', indicador)
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
